export const USER_GROUP_TYPE = 'user' as const;

export const GROUP_TYPES = [USER_GROUP_TYPE, 'team', 'guild', 'game'] as const;

export type GroupType = (typeof GROUP_TYPES)[number];
